import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
export type OnBackgroundJobProgressSubscriptionVariables = Types.Exact<{ [key: string]: never; }>;


export type OnBackgroundJobProgressSubscription = { __typename?: 'Subscription', onBackgroundJobProgress: { __typename?: 'BackgroundJobProgressEvent', jobId: string } };


export const OnBackgroundJobProgressDocument = new TypedDocumentString(`
    subscription OnBackgroundJobProgress {
  onBackgroundJobProgress {
    jobId
  }
}
    `);
